import React from 'react';
import PropTypes from 'prop-types';
import { generateMedia } from 'styled-media-query';
import { rgba, shade } from 'polished';
import { ThemeProvider } from 'styled-components';

const primary = '#C72828';
const primaryLight = '#FF6659';
const secondary = '#FCB84D';
const secondaryLight = '#FDD28E';
const terciary = '#39B101';
const terciaryLight = '#41C900';
const border = '#CECECE';
const white = '#fff';
const black = '#000';
const gray = '#C4C4C4';
const overlay = 'rgba(0, 0, 0, 0.2)';

const mediaBreakpoints = {
  huge: 1440,
  large: 1170,
  medium: 768,
  small: 450,
};

export const theme = {
  colors: {
    primary,
    primaryLight,
    primaryDisabled: rgba(primary, 0.5),
    primaryHover: shade(0.2, primary),
    primaryActive: shade(0.4, primary),
    secondary,
    secondaryLight,
    secondaryDisabled: rgba(secondary, 0.5),
    secondaryHover: shade(0.2, secondary),
    secondaryActive: shade(0.4, secondary),
    terciary,
    terciaryLight,
    terciaryDisabled: rgba(terciary, 0.5),
    terciaryHover: shade(0.2, terciary),
    terciaryActive: shade(0.4, terciary),
    border,
    white,
    black,
    gray,
    grayHover: shade(0.4, gray),
    grayActive: shade(0.6, gray),
    grayDisabled: rgba(gray, 0.5),
  },
  overlay,
  border: `1px solid ${gray}`,
  boxShadow: `3px 3px 4px ${overlay}`,
  fonts: ['sans-serif', 'Roboto'],
  fontSizes: {
    xsmall: '0.75rem', // 12px
    small: '1rem', // 16px
    xmedium: '1.25rem', // 20px
    medium: '2rem', // 32px
    large: '3rem', // 48px
  },
  fontWeights: {
    regular: 400,
    medium: 500,
    bold: 700,
  },
  paddings: {
    xxsmall: '0.625rem',
    xsmall: '0.875rem',
    small: '1rem',
    medium: '2rem',
    large: '3rem',
  },
  radius: {
    small: '0.3125rem', // 5px
    medium: '0.625rem', // 10px
    large: '1rem', // 16px
  },
  mediaBreakpoints,
  media: generateMedia({
    huge: `${mediaBreakpoints.huge}px`,
    large: `${mediaBreakpoints.large}px`,
    medium: `${mediaBreakpoints.medium}px`,
    small: `${mediaBreakpoints.small}px`,
  }),
  minWidth: '288px',
};

export const MyFoodTheme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

MyFoodTheme.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default MyFoodTheme;
